type AgentDebugPayload = {
  hypothesisId?: string;
  location: string;
  message: string;
  data?: Record<string, unknown>;
  runId?: string;
};

/**
 * Same-origin debug log for HTTPS CRA.
 * Prefer GET+query (reliable through webpack-dev-server); fall back to async POST.
 */
export function agentDebugLog(payload: AgentDebugPayload): void {
  const body = JSON.stringify({
    sessionId: "ad91e3",
    runId: payload.runId ?? "validation",
    hypothesisId: payload.hypothesisId,
    location: payload.location,
    message: payload.message,
    data: payload.data ?? {},
    timestamp: Date.now(),
  });

  // #region agent log
  try {
    const url = `/__agent_debug_log?d=${encodeURIComponent(body)}`;
    // GET beacon — does not depend on request body parsing
    fetch(url, { method: "GET", keepalive: true }).catch(() => {});
    // Backup POST
    fetch("/__agent_debug_log", {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (_err) {
    // ignore
  }
  // #endregion
}
